import api from "./api";

export function getVisaFilePage(country_id) {
  return api.get(`/visaappointment/${country_id}`);
}
